// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'dinRoundOT', 'dinRoundOT Fallback', Objektiv, sans-serif"},"className":"__className_05001c","variable":"__variable_05001c"};